<template>
  <el-dialog v-model="visible" title="" width="410" :show-close="true" @close="onClose" :close-on-click-modal="false" :close-on-press-escape="false" style="padding: 32px;">
    <div class="modal-content"  v-if="!bindState">
      <el-tabs v-model="currentForm" class="demo-tabs"  stretch  style="width: 100%;">
        <el-tab-pane label="微信登录" name="wechat" v-if="false">
          <div class="flex flex-col justify-center items-center h-64" v-if="loginStatus === 'waiting'">
            <img :src="loginQrcodeUrl" alt="微信登录二维码" class="w-40 h-40">
            <p class="text-center mt-4">请使用微信扫一扫，关注公众号后直接登录</p>
          </div>
          <div class="flex flex-col justify-center items-center h-64 " v-if="loginStatus === 'expired'">
            <div class="relative w-40 h-40" @click="refreshQRCode">
              <img src="../assets/images/index/expired_qrcode.png" alt="微信登录二维码" class="w-40 h-40">
              <p class="text-center  absolute top-[50%] left-[50%] font-bold text-[#555555]" style="transform: translate(-50%,-50%);">二维码已过期</p>
              <p class="text-center  absolute top-[65%] left-[50%] font-bold text-blue-500 z-100" style="transform: translate(-50%,-50%);" >刷新二维码</p>
            </div>
            <p class="text-center mt-4">请使用微信扫一扫，关注公众号后直接登录</p>
            
          </div>
        </el-tab-pane>
        <el-tab-pane label="密码登录" name="password" style="margin-top: 30px;">
          <el-form @submit.prevent="onSubmit" label-position="top">
            <el-form-item label="手 机">
              <el-input v-model="pwdLoginParams.phone" placeholder="请输入手机号" size="large"/>
            </el-form-item>
            <el-form-item label="密 码">
              <el-input v-model="pwdLoginParams.password" type="password"  size="large" placeholder="请输入密码" />
            </el-form-item>
            <el-button type="primary" @click="pwdLoginFn" style="width: 100%;">立即登录</el-button>
            <el-link type="primary" style="margin-top: 20px;" @click="currentForm='sms'">忘记密码？使用短信登录</el-link>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="短信登录" name="sms" style="margin-top: 30px;">
          <el-alert
            title="未注册用户将自动注册账号"
            type="warning"
            description=""
            show-icon
            style="margin-bottom: 20px;margin-top: -20px;"
          />
          <el-form @submit.prevent="onSubmit" label-position="top">
            <el-form-item label="手机号">
              <el-input v-model="phone" placeholder="请输入手机号"  size="large" />
            </el-form-item>
            <el-form-item label="图形验证码">
              <el-input  v-model="sendSmsParams.captcha" placeholder="请输入验证码"  size="large" style="width:200px"> </el-input>
              <img :src="captchaImgUrl" style="width: 100px; margin-left: 18px; display: inline-block" @click="getSmsCaptchaFn">
            </el-form-item>
            <el-form-item label="短信验证码">
              <el-input v-model="smsLoginParams.code" placeholder="请输入验证码"  size="large">
                <template #append>
                  <el-button type="primary" @click="sendSmsHandle" plain v-if="!startCountDowned">发送验证码</el-button>
                  <div class="count-down-text-btn" v-show="startCountDowned">
                    <el-countdown :value="twoMinutesInMs"  @finish="onFinish" format="mm:ss" />
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-button type="primary" @click="smsLoginFn" style="width: 100%;">立即登录</el-button>
          </el-form>
        </el-tab-pane>
       
      </el-tabs>
    </div>
    <div class="modal-content"  v-if="bindState">
          <h3 class="text-center font-bold text-[16px] color-[#555555]">绑定手机号</h3>
          <el-divider style="margin-top: 10px;"/>
          <el-form @submit.prevent="onSubmit" label-position="top">
            <el-form-item label="手机号">
              <el-input v-model="phone" placeholder="请输入手机号"  size="large" />
            </el-form-item>
            <el-form-item label="图形验证码">
              <el-input  v-model="sendSmsParams.captcha" placeholder="请输入验证码"  size="large" style="width:200px"> </el-input>
              <img :src="captchaImgUrl" style="width: 100px; margin-left: 18px; display: inline-block" @click="getSmsCaptchaFn">
            </el-form-item>
            <el-form-item label="短信验证码">
              <el-input v-model="bindPhoneParams.code" placeholder="请输入验证码"  size="large">
                <template #append>
                  <el-button type="primary" @click="sendSmsHandle" plain v-if="!startCountDowned">发送验证码</el-button>
                  <div class="count-down-text-btn" v-show="startCountDowned">
                    <el-countdown :value="twoMinutesInMs"  @finish="onFinish" format="mm:ss" />
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-button type="primary" @click="openidBindPhone" style="width: 100%;">立即绑定</el-button>
            <div class="text-center mt-2 text-blue-400">一次绑定，后续直接微信登录，可随时解绑</div>
          </el-form>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import UserService from '../apis/UserService';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../constants/Index';
// import dayjs from 'dayjs'

const startCountDowned = ref(false);
const twoMinutesInMs = ref(Date.now() + 2 * 60 * 1000);

// 是否是绑定手机号码状态
const bindState = ref(false)

// Props 和 Emits 定义
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(['update:show', 'login:success']);

// 变量定义
const visible = ref(props.show);
const currentForm = ref<'password' | 'sms' | 'wechat'>('sms');
const phone = ref('');
const captchaImgUrl = ref('');
const loginQrcodeUrl = ref('');
const sceneStr = ref('')
const loginStatus = ref('waiting')
// @ts-ignore
let pollInterval = null
const pollIntervalTime = 3000; // 5 秒

const sendSmsParams = ref({
  phone,
  captcha: "",
  captchaKey: ""
});

const pwdLoginParams = ref({
  phone,
  password: ''
});

const smsLoginParams = ref({
  phone,
  code: ""
});

const bindPhoneParams = ref({
  phone,
  code: "",
  wxOpenid: ""
});


// 监听 currentForm 的变化来更新
watch(currentForm, (newVal) => {
  console.log("watch currentForm:" + newVal);
  if (newVal == 'sms') {
    getSmsCaptchaFn();
    //@ts-ignore
    clearInterval(pollInterval)
  }else if(newVal =='password'){
    //@ts-ignore
    clearInterval(pollInterval)
  }else if (newVal =='wechat'){
    // pollInterval = setInterval(pollLoginStatus, pollIntervalTime)
    // 获取微信登录二维码
    setTimeout(() => {
      getWechatLoginQrCodeFn(); 
    },1000)
  }
});

// 监听 props.show 的变化来更新 visible
watch(() => props.show, (newVal) => {
  visible.value = newVal;
  bindState.value = false;
  console.log("watch props.show:" + newVal,currentForm);
  if (newVal && currentForm.value =='wechat') {
    // 显示时，获取微信登录二维码
    // getWechatLoginQrCodeFn();
    // getSmsCaptchaFn();
    // pollInterval = setInterval(pollLoginStatus, pollIntervalTime)    
  }else if(newVal && currentForm.value =='sms'){
    getSmsCaptchaFn();
    //@ts-ignore
    clearInterval(pollInterval)
  }
  
});

// 当 el-dialog 关闭时触发的事件处理函数
const onClose = () => {
  // 清空定时器
  //@ts-ignore 
  clearInterval(pollInterval)
  visible.value = false;
  bindState.value = false;
  emit('update:show', false);
};

// 获取微信登录二维码
const getWechatLoginQrCodeFn = () => {
  UserService.getWechatLoginQrCode().then(res => {
    if (res.code == 1) {
      console.log("===================获取微信登录二维码");
      // loginQrcodeUrl.value = res.data  ; 
      sceneStr.value = res.data.sceneStr;
      loginQrcodeUrl.value = res.data.qrCodeUrl;
      loginStatus.value = 'waiting'
    } else {
      console.log("获取二维码服务异常");
    }
  })  
}
// 刷新二维码
const refreshQRCode = () => {
  //@ts-ignore 
  clearInterval(pollInterval)
  getWechatLoginQrCodeFn()
  pollInterval = setInterval(pollLoginStatus, pollIntervalTime)
}

// 获取图形验证码
const getSmsCaptchaFn = () => {
  setTimeout(() => {
    UserService.getSmsCaptcha().then(res => {
      if (res.code == 1) {
        console.log("===================获取图片验证码");
        captchaImgUrl.value = res.data.captchaUrl;
        sendSmsParams.value.captchaKey = res.data.captchaKey;
      } else {
        console.log("服务异常");
      }
    });
  }, 600);
};

const onFinish = () => {
  // 倒计时结束
  startCountDowned.value = false;
};

const sendSmsHandle = () => {
  if (!phone.value || !sendSmsParams.value.captcha) {
    ElMessage.error("请填写完整参数");
    return;
  }
  UserService.sendSmsV1(sendSmsParams.value).then(res => {
    if (res.code == 1) {
      ElMessage.success("发送成功");
      startCountDowned.value = true;
      twoMinutesInMs.value =  Date.now() + 2 * 60 * 1000
      return;
    } else {
      ElMessage.error("发送失败");
      startCountDowned.value = true;
      twoMinutesInMs.value =  Date.now() + 2 * 60 * 1000

    }
  });
};

// 提交表单
const onSubmit = async (values: any) => {
  console.log('submit', values);
  if (currentForm.value === 'password') {
    pwdLoginFn(values);
  } else if (currentForm.value === 'sms') {
    smsLoginFn(values);
  }
};

// 账号密码登录
const pwdLoginFn = (values: object) => {
  console.log(values);
  const postParams = { ...pwdLoginParams.value };
  console.log(postParams);
  if (!postParams.phone || !postParams.password) {
    ElMessage.error("请填写完整参数");
    return;
  }
  UserService.login(postParams).then(async (res) => {
    if (res.code == 1) {
      ElMessage.success("登录成功");
      CommonUtils.setLocalStore(Constants.TokenKey, res.data.token);
      CommonUtils.setLocalStore(Constants.PhoneKey, res.data.phone);
      if (res.data.nickName) {
        CommonUtils.setLocalStore(Constants.NickNamekey, res.data.nickName);
      }
      setTimeout(() => {
        visible.value = false;
        emit('login:success');
      }, 100);
    } else {
      ElMessage.error(res.msg);
    }
  }).catch(err => {
    console.log(err);
  });
};



// 短信验证码登录
const smsLoginFn = (values: object) => {
  console.log(values);
  const postParams = { ...smsLoginParams.value };
  console.log(postParams);
  if (!postParams.phone || !postParams.code) {
    ElMessage.error("请填写完整参数");
    return;
  }
  UserService.loginBySms(postParams).then(async (res) => {
    if (res.code == 1) {
      ElMessage.success("登录成功");
      CommonUtils.setLocalStore(Constants.TokenKey, res.data.token);
      CommonUtils.setLocalStore(Constants.PhoneKey, res.data.phone);
      if (res.data.nickName) {
        CommonUtils.setLocalStore(Constants.NickNamekey, res.data.nickName);
      }
      setTimeout(() => {
        visible.value = false;
        emit('login:success');
      }, 1000);
    } else if (res.code == 10011) {
      ElMessage.error("验证码不存在");
      return;
    }
  }).catch(err => {
    console.log(err);
  });
};

//openidBindPhone 微信openid绑定手机号码 
const openidBindPhone = () => {
  const postParams = {...bindPhoneParams.value };
  console.log(postParams);
  if (!postParams.phone || !postParams.code ||!postParams.wxOpenid) {
    ElMessage.error("请填写完整参数");
    return;
  }
  UserService.wxOpenIdBindPhoneHandle(postParams).then(async (res) => {
    if (res.code == 1) {
      ElMessage.success("登录成功");
      CommonUtils.setLocalStore(Constants.TokenKey, res.data.token);
      CommonUtils.setLocalStore(Constants.PhoneKey, res.data.phone);
      if (res.data.nickName) {
        CommonUtils.setLocalStore(Constants.NickNamekey, res.data.nickName);
      }
      setTimeout(() => { 
        visible.value = false;
        bindState.value = false;
        emit('login:success');
      }, 1000);
    } else if (res.code == 10011) {
      ElMessage.error("验证码不存在");
      return;
    }
  }).catch(err => {
    console.log(err);
  });
}
// 轮询登录状态
const pollLoginStatus = () => {
  UserService.getWxLoginState(sceneStr.value).then(res => {
    // waiting,expired,followed，success
    if(res.code == 1){
      let state = res.data && res.data.wxLoginQrcodeState as string;
      if(state.toLowerCase() == 'expired'){
        loginStatus.value = 'expired'
      }else if(state.toLowerCase() == 'followed'){
        // 已经关注，如果phone为空，需要跳转到绑定页面，否则直接登录
        if(!res.data.phone){
          bindPhoneParams.value.wxOpenid = res.data.wxOpenid;
          // 清除定时器
          //@ts-ignore
          clearInterval(pollInterval)
           // 跳转到绑定手机号码页面
           bindState.value = true;
        }
        
      }else if(state.toLowerCase() == 'success'){
        // 已经关注，且phone应该不为空
        if(res.data.phone && res.data.token){
          // 登录成功，关闭弹窗，跳转到首页
          ElMessage.success("登录成功");
          CommonUtils.setLocalStore(Constants.TokenKey, res.data.token);
          CommonUtils.setLocalStore(Constants.PhoneKey, res.data.phone);
          if (res.data.nickName) {
            CommonUtils.setLocalStore(Constants.NickNamekey, res.data.nickName);
          }
          setTimeout(() => {
            visible.value = false;   
            emit('login:success');
          }, 1000);
        }
        
      }else {
        loginStatus.value = 'waiting' 
        bindState.value = false;
      }
    }
  })  
}

onUnmounted(() => {
  //@ts-ignore
  clearInterval(pollInterval);
})

</script>

<style scoped>
.modal-content {
  padding: 2px;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  position: relative;
}

.header {
  text-align: right;
}

.close-btn {
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: color 0.3s ease;
}

.close-btn:hover {
  color: #333;
}

.login-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.styled-input {
  margin-bottom: 15px;
}

/* 删除默认边框并增强底部线条 */
:deep(.van-cell:not(:last-child)::after) {
  border-bottom: 2px solid #ebedf0;
  left: 0;
  right: 0;
}

.captcha-image {
  height: 36px;
  cursor: pointer;
  border-radius: 4px;
}

.button-container {
  margin-top: 20px;
  padding: 0 32px;
}

.block-button {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  border-radius: 8px;
}

.login-options {
  text-align: left;
  margin-top: 20px;
}

.login-options span {
  color: #047bf1;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;
  display: inline-block;
  font-size: 18px;
}

.login-options span:hover {
  color: #0e67c7;
}
</style>

<style>
.modal-content .el-count-down {
  display: inline-block;
  color: #df0019;
  font-weight: bold;
  background: #c8c9cc;
  text-align: center;
  border-radius: 6px;
  font-size: 16px;
  padding: 6px 16px;
}
</style>